import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
  Class,
  DirectMessageTemplate,
  Employee,
  Location,
  MessageType,
  ProvinceState,
  ServiceCode,
  TechnicianGroup,
  TransportOption,
  WarrantySubmissionType,
  VehicleColour as Colour,
  SubType,
  VehicleInspectionWearPattern,
  VehicleMake
} from '@quorum/models/xs-resource';
import { ServiceLaneDropdownsAction, ServiceLaneDropdownsActionTypes } from './service-lane-dropdowns.actions';

export const SERVICELANEDROPDOWNS_FEATURE_KEY = 'serviceLaneDropdowns';

export class DeclinedReasonWithDefault {
  id: number = null;
  includeOnServiceNoticeFlag: boolean = null;
  moveToQuoteHistoryFlag: boolean = null;
  reason: string = null;
  rooftopId: number = null;
  isDefault: boolean = null;

  constructor(obj?: DeclinedReasonWithDefault) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

//#region locations
export interface LocationsState extends EntityState<Location> {}
export const locationsAdapter: EntityAdapter<Location> = createEntityAdapter<Location>({
  selectId: (location: Location) => location.id,
});
export const initialLocationsState: LocationsState = locationsAdapter.getInitialState({});
//#endregion

//#region message-types
export interface MessageTypesState extends EntityState<MessageType> {}
export const messageTypesAdapter: EntityAdapter<MessageType> = createEntityAdapter<MessageType>({
  selectId: (messageType: MessageType) => messageType.id,
});
export const initialMessageTypesState: MessageTypesState = messageTypesAdapter.getInitialState({});
//#endregion

//#region associate-classes
export interface AssociateClassesState extends EntityState<Class> {}
export const associateClassesAdapter: EntityAdapter<Class> = createEntityAdapter<Class>({
  selectId: (associateClass: Class) => associateClass.id,
});
export const initialAssociateClassesState: AssociateClassesState = associateClassesAdapter.getInitialState({});
//#endregion

//#region province/states
export interface ProvinceStatesState extends EntityState<ProvinceState> {}
export const provinceStatesAdapter: EntityAdapter<ProvinceState> = createEntityAdapter<ProvinceState>({});
export const initialProvinceStatesState: ProvinceStatesState = provinceStatesAdapter.getInitialState({});
//#endregion

//#region service-codes
export interface ServiceCodesState extends EntityState<ServiceCode> {}
export const serviceCodesAdapter: EntityAdapter<ServiceCode> = createEntityAdapter<ServiceCode>({
  selectId: (serviceCode: ServiceCode) => serviceCode.serviceCode,
});
export const initialServiceCodesState: ServiceCodesState = serviceCodesAdapter.getInitialState({});
//#endregion

//#region service-codes
export interface EmployeesState extends EntityState<Employee> {}
export const employeesAdapter: EntityAdapter<Employee> = createEntityAdapter<Employee>({
  selectId: (emp: Employee) => emp.associateId,
});
export const initialEmployeesState: EmployeesState = employeesAdapter.getInitialState({});
//#endregion

//#region technician-group
export interface TechnicianGroupsState extends EntityState<TechnicianGroup> {}
export const technicianGroupsAdapter: EntityAdapter<TechnicianGroup> = createEntityAdapter<TechnicianGroup>({
  selectId: (tg: TechnicianGroup) => tg.id,
});
export const initialTechnicianGroupsState: TechnicianGroupsState = technicianGroupsAdapter.getInitialState({});
//#endregion

//#region vehicle Colours
export interface VehicleColoursState extends EntityState<Colour> {}
export const vehicleColourAdapter: EntityAdapter<Colour> = createEntityAdapter<Colour>({
  selectId: (st: Colour) => st.id,
});
export const initialVehicleColourState: VehicleColoursState = vehicleColourAdapter.getInitialState({});
//#endregion

//#region vehicle Colours
export interface VehicleSubTypesState extends EntityState<SubType> {}
export const vehicleSubTypeAdapter: EntityAdapter<SubType> = createEntityAdapter<SubType>({
  selectId: (st: SubType) => st.id,
});
export const initialVehicleSubTypeState: VehicleSubTypesState = vehicleSubTypeAdapter.getInitialState({});
//#endregion

//#region warranty submission type
export interface WarrantySubmissionTypesState extends EntityState<WarrantySubmissionType> {}
export const submissionTypeAdapter: EntityAdapter<WarrantySubmissionType> = createEntityAdapter<WarrantySubmissionType>(
  {
    selectId: (st: WarrantySubmissionType) => st.id,
  }
);
export const initialSubmissionTypeState: WarrantySubmissionTypesState = submissionTypeAdapter.getInitialState({});
//#endregion

//#region directMessageTemplates
export interface DirectMessageTemplatesState extends EntityState<DirectMessageTemplate> {}
export const directMessageTemplatesAdapter: EntityAdapter<DirectMessageTemplate> =
  createEntityAdapter<DirectMessageTemplate>({
    selectId: (directMessageTemplate: DirectMessageTemplate) => directMessageTemplate.id,
  });
// eslint-disable-next-line max-len
export const initialDirectMessageTemplatesState: DirectMessageTemplatesState =
  directMessageTemplatesAdapter.getInitialState({});
//#endregion

//#region transportOptions
export interface TransportOptionsState extends EntityState<TransportOption> {}
export const transportOptionsAdapter: EntityAdapter<TransportOption> = createEntityAdapter<TransportOption>({
  selectId: (transportOption: TransportOption) => transportOption.id,
});
// eslint-disable-next-line max-len
export const initialTransportOptionsState: TransportOptionsState = transportOptionsAdapter.getInitialState({});
//#endregion

//#region vehicleMakes
export interface VehicleMakesState extends EntityState<VehicleMake> {}
export const vehicleMakesAdapter: EntityAdapter<VehicleMake> = createEntityAdapter<VehicleMake>({
  selectId: (vehicleMake: VehicleMake) => vehicleMake.id,
});
// eslint-disable-next-line max-len
export const initialVehicleMakesState: VehicleMakesState = vehicleMakesAdapter.getInitialState({});
//#endregion

//#region declinedReasons
export interface DeclinedReasonsState extends EntityState<DeclinedReasonWithDefault> {}
// eslint-disable-next-line max-len
export const declinedReasonsAdapter: EntityAdapter<DeclinedReasonWithDefault> =
  createEntityAdapter<DeclinedReasonWithDefault>({
    selectId: (declinedReason: DeclinedReasonWithDefault) => declinedReason.id,
  });
// eslint-disable-next-line max-len
export const initialDeclinedReasonsState: DeclinedReasonsState = declinedReasonsAdapter.getInitialState({});
//#endregion

//#region vehicleInspectionWearPatterns
export interface VehicleInspectionWearPatternsState extends EntityState<VehicleInspectionWearPattern> {}
export const vehicleInspectionWearPatternsAdapter: EntityAdapter<VehicleInspectionWearPattern> =
  createEntityAdapter<VehicleInspectionWearPattern>({
    selectId: (vehicleInspectionWearPattern: VehicleInspectionWearPattern) => vehicleInspectionWearPattern.id,
  });
// eslint-disable-next-line max-len
export const initialVehicleInspectionWearPatternsAdapterState: VehicleInspectionWearPatternsState =
  vehicleInspectionWearPatternsAdapter.getInitialState({});
//#endregion

export interface ServiceLaneDropdownsState {
  locations: LocationsState;
  messageTypes: MessageTypesState;
  associateClasses: AssociateClassesState;
  provinceStates: ProvinceStatesState;
  serviceCodes: ServiceCodesState;
  employees: EmployeesState;
  technicianGroups: TechnicianGroupsState;
  vehicleColours: VehicleColoursState;
  vehicleSubTypes: VehicleSubTypesState;
  vehicleMakes: VehicleMakesState;
  warrantySubmissionTypes: WarrantySubmissionTypesState;
  directMessageTemplates: DirectMessageTemplatesState;
  transportOptions: TransportOptionsState;
  declinedReasons: DeclinedReasonsState;
  vehicleInspectionWearPatterns: VehicleInspectionWearPatternsState;
}

export interface ServiceLaneDropdownsPartialState {
  readonly [SERVICELANEDROPDOWNS_FEATURE_KEY]: ServiceLaneDropdownsState;
}

export const initialState: ServiceLaneDropdownsState = {
  locations: initialLocationsState,
  messageTypes: initialMessageTypesState,
  associateClasses: initialAssociateClassesState,
  provinceStates: initialProvinceStatesState,
  serviceCodes: initialServiceCodesState,
  employees: initialEmployeesState,
  technicianGroups: initialTechnicianGroupsState,
  vehicleColours: initialVehicleColourState,
  vehicleSubTypes: initialVehicleSubTypeState,
  vehicleMakes: initialVehicleMakesState,
  vehicleInspectionWearPatterns: initialVehicleInspectionWearPatternsAdapterState,
  warrantySubmissionTypes: initialSubmissionTypeState,
  directMessageTemplates: initialDirectMessageTemplatesState,
  transportOptions: initialTransportOptionsState,
  declinedReasons: initialDeclinedReasonsState,
};

export function serviceLaneDropdownsReducer(
  state: ServiceLaneDropdownsState = initialState,
  action: ServiceLaneDropdownsAction
): ServiceLaneDropdownsState {
  switch (action.type) {
    case ServiceLaneDropdownsActionTypes.GetDirectMessageTemplatesFromServerSuccess: {
      state = {
        ...state,
        directMessageTemplates: directMessageTemplatesAdapter.addMany(action.payload, state.directMessageTemplates),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetLocationsFromServerSuccess: {
      state = {
        ...state,
        locations: locationsAdapter.addMany(action.payload, state.locations),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetMessageTypesFromServerSuccess: {
      state = {
        ...state,
        messageTypes: messageTypesAdapter.addMany(action.payload, state.messageTypes),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetAssociateClassesFromServerSuccess: {
      state = {
        ...state,
        associateClasses: associateClassesAdapter.addMany(action.payload, state.associateClasses),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetProvinceStatesFromServerSuccess: {
      state = {
        ...state,
        provinceStates: provinceStatesAdapter.addMany(action.payload, state.provinceStates),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetEmployeesFromServerSuccess: {
      state = {
        ...state,
        employees: employeesAdapter.addMany(action.payload, state.employees),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetServiceCodesFromServerSuccess: {
      state = {
        ...state,
        serviceCodes: serviceCodesAdapter.addMany(action.payload, state.serviceCodes),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetTechnicianGroupsFromServerSuccess: {
      state = {
        ...state,
        technicianGroups: technicianGroupsAdapter.addMany(action.payload, state.technicianGroups),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetVehicleColoursFromServerSuccess: {
      state = {
        ...state,
        vehicleColours: vehicleColourAdapter.addMany(action.payload, state.vehicleColours),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetVehicleSubTypesFromServerSuccess: {
      state = {
        ...state,
        vehicleSubTypes: vehicleSubTypeAdapter.addMany(action.payload, state.vehicleSubTypes),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetVehicleMakesFromServerSuccess: {
      state = {
        ...state,
        vehicleMakes: vehicleMakesAdapter.addMany(action.payload, state.vehicleMakes),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetWarrantySubmissionTypesFromServerSuccess: {
      state = {
        ...state,
        warrantySubmissionTypes: submissionTypeAdapter.addMany(action.payload, state.warrantySubmissionTypes),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetTransportOptionsFromServerSuccess: {
      state = {
        ...state,
        transportOptions: transportOptionsAdapter.addMany(action.payload, state.transportOptions),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetDeclinedReasonsFromServerSuccess: {
      state = {
        ...state,
        declinedReasons: declinedReasonsAdapter.addMany(action.payload, state.declinedReasons),
      };
      break;
    }
    case ServiceLaneDropdownsActionTypes.GetVehicleInspectionWearPatternsFromServerSuccess: {
      state = {
        ...state,
        // eslint-disable-next-line max-len
        vehicleInspectionWearPatterns: vehicleInspectionWearPatternsAdapter.addMany(
          action.payload,
          state.vehicleInspectionWearPatterns
        ),
      };
      break;
    }
  }
  return state;
}
